import { Field } from 'formik';
import React from 'react';
import VerificationField from './VerificationField';

const FIELD_NAME = 'number';

const VerificationFormFields = ({
    values,
    setFieldValue,
    submitForm,
    disabled,
}: {
    values: any;
    setFieldValue: (name: string, value: string) => void;
    submitForm: (values: { [x: string]: string }) => void;
    disabled: boolean;
}) => {
    const [nextFocusElement, setNextFocusElement] = React.useState<number>(1);
    const fields: React.ReactElement[] = [];

    React.useEffect(() => {
        submitForm(values);
    }, [values, submitForm]);

    const handleFieldPaste = (event: any) => {
        const text = event.clipboardData.getData('Text');

        // Only paste complete codes
        if (text.length === 6) {
            for (let index = 1; index <= 6; index++) {
                const name = `${FIELD_NAME}${index}`;
                const inputValue = text[index - 1];

                setFieldValue(name, inputValue);
            }
        }
    };

    for (let index = 1; index <= 6; index++) {
        const name = `${FIELD_NAME}${index}`;

        fields.push(
            <Field
                key={name}
                name={name}
                elementNumber={index}
                component={VerificationField}
                value={values[name]}
                onChange={(value: number) => {
                    setNextFocusElement(value);
                }}
                onInvalidValue={() => {
                    setFieldValue(name, '');
                }}
                shouldFocus={nextFocusElement === index}
                onPaste={handleFieldPaste}
                disabled={disabled}
            />,
        );
    }

    return <>{fields}</>;
};

export default VerificationFormFields;
